import i18n from '@/utils/i18n';
import React from 'react';
import { ItemContext_SaltItemFieldsFragment } from '@/types';
import { RichInfoSaltAllergens } from './rich-info-salt-allergens';
import { RichInfoSaltNutrients } from './rich-info-salt-nutrients';
import { RichInfoSaltProductSpecs } from './rich-info-salt-product-specs';
import { RichInfoSection } from './rich-info-section';
import { StyleSheet, Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  horizontal?: boolean;
  saltItemInfo: ItemContext_SaltItemFieldsFragment;
}

export const SaltItemRichInfo: React.FC<Props> = ({
  saltItemInfo,
  horizontal,
}) => {
  return (
    <>
      <RichInfoSaltAllergens saltItemInfo={saltItemInfo} />
      {saltItemInfo?.dietaryInformation.ingredients.length ? (
        <RichInfoSection horizontal={horizontal} title={i18n.t('ingredients')}>
          <Text style={[TYPOGRAPHY.small, styles.ingredients]}>
            {saltItemInfo.dietaryInformation.ingredients.join(', ')}
          </Text>
        </RichInfoSection>
      ) : null}
      {saltItemInfo && saltItemInfo.dietaryInformation.nutrients.length ? (
        <RichInfoSaltNutrients
          horizontal={horizontal}
          saltItemInfo={saltItemInfo}
        />
      ) : null}
      {saltItemInfo ? (
        <RichInfoSaltProductSpecs
          horizontal={horizontal}
          saltItemInfo={saltItemInfo}
        />
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  ingredients: {
    lineHeight: 16,
    // behaves differently on web and native
    // web will keep everything uppercase
    textTransform: 'capitalize',
  },
});
